module.exports = __webpack_public_path__ + "img/fzlc2019.ed6e7da3.png";